import {
  GET_ALL_NON_WORKING_HOURS,
  GET_ALL_NON_WORKING_HOURS_ERROR,
  GET_ALL_NON_WORKING_HOURS_SUCCESS,
  INSERT_UPDATE_NON_WORKING_HOURS,
  INSERT_UPDATE_NON_WORKING_HOURS_SUCCESS,
  INSERT_UPDATE_NON_WORKING_HOURS_ERROR,
  DELETE_NON_WORKING_HOURS,
  DELETE_NON_WORKING_HOURS_SUCCESS,
  DELETE_NON_WORKING_HOURS_ERROR,
} from "./actionType"

// scrutiny type
export const GetAllNonWorkingHours = nonworkinghours => {
  return {
    type: GET_ALL_NON_WORKING_HOURS,
    payload: nonworkinghours,
  }
}

export const GetAllNonWorkingHoursSuccess = nonworkinghours => {
  return {
    type: GET_ALL_NON_WORKING_HOURS_SUCCESS,
    payload: nonworkinghours,
  }
}

export const GetAllNonWorkingHoursError = nonworkinghours => {
  return {
    type: GET_ALL_NON_WORKING_HOURS_ERROR,
    payload: nonworkinghours,
  }
}

// upate calculate incentive incentives
export const insertupdateNonWorkinghours = (nonworkinghours, callback) => {
  return {
    type: INSERT_UPDATE_NON_WORKING_HOURS,
    payload: nonworkinghours,
    callback
  }
}

export const insertupdateNonWorkinghoursSuccess = nonworkinghours => {
  return {
    type: INSERT_UPDATE_NON_WORKING_HOURS_SUCCESS,
    payload: nonworkinghours,
  }
}

export const insertupdateNonWorkinghoursError = nonworkinghours => {
  return {
    type: INSERT_UPDATE_NON_WORKING_HOURS_ERROR,
    payload: nonworkinghours,
  }
}

// delete calculate incentive incentives
export const deleteNonWorkinghours = id => {
  return {
    type: DELETE_NON_WORKING_HOURS,
    payload: id,
  }
}

export const deleteNonWorkinghoursSuccess = nonworkinghours => {
  return {
    type: DELETE_NON_WORKING_HOURS_SUCCESS,
    payload: nonworkinghours,
  }
}

export const deleteNonWorkinghoursError = nonworkinghours => {
  return {
    type: DELETE_NON_WORKING_HOURS_ERROR,
    payload: nonworkinghours,
  }
}
